import { extend, forEach } from 'lodash';

/**
 * @param {Array<object>} times
 * @param {string} doctorLocationId
 */
export default function parseTimeslots(times, doctorLocationId) {
    const timeslots = {};

    forEach(times, doctorLocationTimes => {
        doctorLocationTimes.appointments.forEach(appointment => {
            timeslots[appointment.id] = extend({
                doctorLocationId,
            }, appointment);
        });
    });

    return timeslots;
}
